import { PASSWORD_TOO_SHORT } from '../constants';

export function ValidatePassword(password = '') {
  const errors = [];

  if (password.length < 12) errors.push(PASSWORD_TOO_SHORT);

  return errors;
}
